import { TextField, styled } from "@mui/material";

export const CustomTextField = styled(TextField, {
  shouldForwardProp: (props) => props !== "focusColor",
})((p) => ({
  "& label.Mui-focused": {
    color: p.focusColor,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: p.focusColor,
  },
  "& .MuiFilledInput-underline:after": {
    borderBottomColor: p.focusColor,
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor: p.focusColor,
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "14px",
    top: p.value ? "0px" : "-5px",
    "@media (max-width: 2000px) and (min-width: 1800px)": {
      fontSize: "17px",
    },
    "@media (max-width: 1800px) and (min-width: 1400px)": {
      fontSize: "15px",
    },
    "@media (max-width: 1400px) and (min-width: 1000px)": {
      fontSize: "13px",
    },
    "@media (max-width: 1000px) and (min-width: 769px)": {
      fontSize: "12px",
    },
    "@media (max-width: 687px)": {
      top: "0px",
      fontSize: "10px",
    }
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "14px",
    height: "12px",
    "@media (max-width: 2200px) and (min-width: 2000px)": {
      fontSize: "22px",
      height: "15px",
    },
    "@media (max-width: 2000px) and (min-width: 1800px)": {
      fontSize: "17px",
    },
    "@media (max-width: 1800px) and (min-width: 1400px)": {
      fontSize: "15px",
    },
    "@media (max-width: 1400px) and (min-width: 1000px)": {
      fontSize: "13px",
    },
    "@media (max-width: 1000px) and (min-width: 960px)": {
      fontSize: "12px",
    },
    "@media (max-width: 960px) and (min-width: 769px)": {
      fontSize: "12px",
    },
    "@media (max-width: 768px) and (min-width: 687px)": {
      fontSize: "20px",
      height: "15px"
    },
    "@media (max-width: 687px)": {
      fontSize: "12px",
      height: "8px"
    },
  },
  "& .MuiInputBase-root": {
    fontSize: "14px",
    "@media (max-width: 2000px) and (min-width: 1800px)": {
      fontSize: "17px",
    },
    "@media (max-width: 1800px) and (min-width: 1400px)": {
      fontSize: "15px",
    },
    "@media (max-width: 1400px) and (min-width: 1000px)": {
      fontSize: "13px",
    },
    "@media (max-width: 1000px) and (min-width: 769px)": {
      fontSize: "12px",
    },
    "@media (max-width: 1200px) and (min-width: 1000px)": {
      fontSize: "10px",
    },
  },
  "& .MuiFormHelperText-root": {
    color: "red",
    fontSize: "10px",
    fontWeight: "600",
    "@media (max-width: 960px) and (min-width: 688px)": {
      fontSize: "8px",
    },
    "@media (max-width: 687px)": {
      fontSize: "7px",
    },
  },
}));

export const CustomDisabledTextfield = styled(TextField, {
  shouldForwardProp: (props) => props !== "focusColor",
})((p) => ({
  "& .MuiInputBase-input.Mui-disabled": {
    color: "black",
    backgroundColor: "#E9E9E5",
    borderColor: "black",
    fontSize: "14px",
    top: p.value ? "0px" : "-5px",
    WebkitTextFillColor: "black",
    "@media (max-width: 960px) and (min-width: 688px)": {
      fontSize: "12px",
    },
    "@media (max-width: 687px)": {
      top: "0px",
      fontSize: "10px",
    }
  },
  "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "black",
    fontSize: "14px",
    "@media (max-width: 960px) and (min-width: 688px)": {
      fontSize: "12px",
    },
    "@media (max-width: 687px)": {
      fontSize: "10px",
    },
  },
  "& .MuiInputLabel-root": {
    "&.Mui-disabled": {
      fontSize: "14px",
      color: "black",
      "@media (max-width: 960px) and (min-width: 688px)": {
        fontSize: "12px",
      },
      "@media (max-width: 687px)": {
        fontSize: "10px",
      },
    },
  },
  "& .css-j3ly30-MuiFormControl-root-MuiTextField-root": {
    "&.MuiInputBase-input.Mui-disabled": {
      fontSize: "14px",
      "@media (max-width: 960px) and (min-width: 688px)": {
        fontSize: "12px",
      },
      "@media (max-width: 687px)": {
        fontSize: "10px",
      },
    },
  },
  "& .MuiOutlinedInput-input": {
    height: "12px",
  },
}));
